<template>
	<div class="user-center-container">
		<div class="user-center-header filter-container">
			<div class="filter-tabs">
				<div
					v-for="(tab, index) in monitorTags"
					:key="index"
					:class="['tab-item', { active: searchForm.activeType === tab.value }]"
					@click="handleTabChange(tab.value)"
				>
					{{ tab.label }}
				</div>
			</div>

			<div class="filter-options">
				<div class="date-filter">
					<el-date-picker
						v-model="customData"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						@change="handleChangeCustomDate"
					></el-date-picker>
					<el-input
						v-model="searchForm.name"
						:placeholder="searchForm.activeType === '1' ? '请输入企业名称' : '请输入人员名称'"
						class="search-input"
						@keyup.enter.native="initMonitorList"
					></el-input>
					<el-button type="primary" @click="initMonitorList">查询</el-button>
					<el-button @click="resetSearchForm">重置</el-button>
				</div>
			</div>
		</div>
		<div class="user-center-content">
			<data-table
				:table-data="monitorList"
				:column="monitorColumns"
				:page-options="pageOptions"
				:border="true"
				:index="true"
				:loading="loading"
				@page-change="handlePaginationChange"
			>
				<template slot="slot_name" slot-scope="data">
					{{ searchForm.activeType === '1' ? data.scope.row.companyName : data.scope.row.name }}
				</template>
				<template slot="slot_tools" slot-scope="data">
					<el-button v-if="searchForm.activeType === '1'" type="text" @click="handleToSetting">监控设置</el-button>
					<el-button type="text" @click="handleRemoveMonitor(data.scope.row.id)">取消监控</el-button>
				</template>
			</data-table>
		</div>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { pageUserMonitoringPerson, pageUserMonitoringUnit } from '@/api/user/monitor'
	import { removeUserMonitoring } from '@/api/userCenter/index'
	import { COLLECT_TYPE_STATE } from '@/enum/index'

	export default {
		name: 'MonitorList',
		components: { DataTable },
		props: {},
		data() {
			return {
				searchForm: {
					activeType: '1',
					name: '', // 文件名
					startTime: '',
					endTime: ''
				},
				// 时间筛选选项
				monitorTags: [
					{ label: '企业', value: '1' },
					{ label: '人员', value: '2' }
				],
				// 时间筛选选项
				dateOptions: [
					{ label: '全部时间', value: 'allTime' },
					{ label: '今日', value: 'today' },
					{ label: '近7天', value: 'week' },
					{ label: '近30天', value: 'month' },
					{ label: '自定义', value: 'custom' }
				],
				currentDate: 'allTime',
				customData: '',

				monitorColumns: [
					{ label: '监控对象', prop: 'name', align: 'center', slot: 'slot_name' },
					{ label: '监控开始时间', prop: 'monitoringTime', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools', width: '200' }
				],
				monitorList: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				}
			}
		},
		computed: {},
		watch: {},
		created() {
			this.initMonitorList()
		},
		mounted() {},
		methods: {
			// TODO: 初始化导出记录
			initMonitorList() {
				this.loading = true
				const params = {
					startTime: this.searchForm.startTime,
					endTime: this.searchForm.endTime,
					page: this.pageOptions.page,
					size: this.pageOptions.limit
				}
				if (this.searchForm.activeType === '1') {
					params.companyName = this.searchForm.name
					pageUserMonitoringUnit(params)
						.then(res => {
							this.monitorList = res.data.records
							this.pageOptions.total = res.data.total
							this.loading = false
						})
						.catch(err => {
							this.loading = false
						})
				} else if (this.searchForm.activeType === '2') {
					params.name = this.searchForm.name
					pageUserMonitoringPerson(params)
						.then(res => {
							this.monitorList = res.data.records
							this.pageOptions.total = res.data.total
							this.loading = false
						})
						.catch(err => {
							this.loading = false
						})
				}
			},
			// TODO: 根据tab筛选消息
			handleTabChange(tab) {
				this.searchForm.activeType = tab
				this.initMonitorList()
			},
			// 切换时间查询
			handleDateChange(date) {
				this.currentDate = date
				const now = new Date()
				const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const weekAgo = new Date(today)
				const monthAgo = new Date(today)
				// 修正为本地时间格式
				const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
					today.getDate()
				).padStart(2, '0')}`

				switch (date) {
					case 'allTime':
						this.searchForm.startTime = ''
						this.searchForm.endTime = ''
						break
					case 'today':
						this.searchForm.startTime = todayStr
						this.searchForm.endTime = todayStr
						break
					case 'week':
						weekAgo.setDate(weekAgo.getDate() - 6) // 包含今天共7天
						this.searchForm.startTime = weekAgo.toISOString().split('T')[0]
						this.searchForm.endTime = todayStr
						break
					case 'month':
						monthAgo.setMonth(monthAgo.getMonth() - 1)
						monthAgo.setDate(monthAgo.getDate() + 1) // 包含今天共30天
						this.searchForm.startTime = monthAgo.toISOString().split('T')[0]
						this.searchForm.endTime = todayStr
						break
					case 'custom':
						// 自定义时间段由el-date-picker处理
						break
				}
				if (date !== 'custom') {
					this.initMonitorList()
				}
			},
			// 自定义时间查询
			handleChangeCustomDate(value) {
				if (value) {
					this.searchForm.startTime = value[0]
					this.searchForm.endTime = value[1]
				}
			},
			// 翻页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.initMonitorList()
			},
			// 跳转监控设置
			handleToSetting() {
				this.$router.push({
					path: '/user/monitor/settings'
				})
			},
			// 取消监控
			handleRemoveMonitor(id) {
				const params = {
					monitoringIds: [id],
					monitoringType: COLLECT_TYPE_STATE.PERSON
				}
				if (this.searchForm.activeType === '1') {
					params.monitoringType = COLLECT_TYPE_STATE.ENTERPRISE
				} else if (this.searchForm.activeType === '2') {
					params.monitoringType = COLLECT_TYPE_STATE.PERSON
				}
				removeUserMonitoring(params).then(res => {
					this.$message.success('已取消监控')
					this.initMonitorList()
				})
			},
			resetSearchForm() {
				this.searchForm = {
					...this.searchForm, // 保留现有属性
					name: '', // 重置名称
					startTime: '', // 重置开始时间
					endTime: '' // 重置结束时间
				}
				this.customData = '' // 同时重置日期选择器
				this.initMonitorList() // 重新加载数据
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	.qualificationQuery-search {
		.searchForm {
			.el-form-item {
				width: 500px;
			}
		}
	}
	.search-input {
		margin: 0px 20px;
		width: 300px;
		height: 35px;
		::v-deep {
			.el-input__inner {
				height: 35px;
				border-radius: 0px;
			}
			.el-input__icon {
				display: flex;
				align-items: center;
			}
		}
	}
	.user-center-container {
		.filter-container {
			.filter-options {
				margin-top: -34px;
				position: relative;
				z-index: 1;

				.date-filter {
					justify-content: flex-end;
					width: 100%;
					position: relative;
					.date-item {
						& + .date-item {
							margin-left: 0px;
						}
					}
					::v-deep {
						.el-button {
							height: 35px;
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: 0px;
						}
						.el-range-editor.el-input__inner {
							height: 35px;
							border-radius: 0px;
							.el-range-separator {
								width: 10%;
							}
						}
						.el-range-separator {
							line-height: 26px;
						}
					}
				}
			}
			.filter-tabs {
				margin-bottom: 0px;
				position: relative;
				z-index: 2;
				width: 25%;
				.active {
					text-decoration: underline;
					text-decoration-color: #409eff;
					text-decoration-thickness: 2px;
					text-underline-offset: 6px;
				}

				.tab-item:hover {
					text-decoration: underline;
					text-decoration-color: #409eff;
					text-decoration-thickness: 2px;
					text-underline-offset: 6px;
				}
			}
		}
	}
</style>
